import { createReducer } from '@reduxjs/toolkit';

import type { InvitationStore } from './types';
import * as actions from './actions';

const initialState: InvitationStore = {
  data: {},
  current: null,
  meta: {
    isLoading: {},
  },
};

export default createReducer(initialState, (builder) => builder
  .addCase(actions.open, (state, action) => {
    const event = { ...action.payload };
    state.data[event.id] = event;
    state.current = {
      id: event.id,
      isOpen: true,
      step: 'attending',
      rsvp: {
        eventId: event.id,
      },
    };
    const invitation = JSON.parse(localStorage.getItem('@invitation') || '{"event": {}}') as Record<string, any>;
    if (invitation.event?.[event.id]?.rsvp?.id) {
      state.current.rsvp.id = invitation.event?.[event.id]?.rsvp?.id;
    }
  })
  .addCase(actions.close, (state) => {
    if (!state.current) {
      return;
    }
    state.current.isOpen = false;
  })
  .addCase(actions.setRSVP, (state, action) => {
    const { payload } = action;
    if (!state.current) {
      return;
    }
    if (payload.mode === 'replace') {
      state.current.rsvp = {
        ...payload.rsvp,
      };
    }
    if (payload.mode === 'update') {
      state.current.rsvp = {
        ...state.current.rsvp,
        ...payload.rsvp,
      };
    }
    const invitation = JSON.parse(localStorage.getItem('@invitation') || '{"event": {}}') as Record<string, any>;
    invitation.event[payload.rsvp.eventId] = {
      id: state.data[state.current.id].id,
      startTime: state.data[state.current.id].startTime,
      endTime: state.data[state.current.id].endTime,
      rsvp: {
        id: payload.rsvp.id,
        eventId: payload.rsvp.eventId,
        status: payload.rsvp.status,
      },
    };
    localStorage.setItem('@invitation', JSON.stringify(invitation));
  })
  .addCase(actions.setStep, (state, action) => {
    const { payload } = action;
    if (!state.current) {
      return;
    }
    state.current.step = payload.name;
  })
  .addCase(actions.sendAnswerAttending, (state) => {
    if (!state.current) {
      return;
    }
    state.meta.isLoading.attending = true;
  })
  .addCase(actions.sendAnswerNotAttending, (state) => {
    if (!state.current) {
      return;
    }
    state.meta.isLoading.notAttending = true;
  })
  .addCase(actions.sendInfo, (state) => {
    if (!state.current) {
      return;
    }
    state.meta.isLoading.info = true;
  })
  .addCase(actions.sendNote, (state) => {
    if (!state.current) {
      return;
    }
    state.meta.isLoading.note = true;
  })
  .addCase(actions.requestDone, (state, action) => {
    const { payload } = action;
    if (payload.name in state.meta.isLoading) {
      delete state.meta.isLoading[payload.name];
    }
  }));
